import { ForgotPasswordPage } from '../../identity/pages/ForgotPasswordPage';
import { PARTNER_RESET_REQUEST_SLIDES } from '../heroSlides';

/** EPN-36 — thin wrapper reusing ForgotPasswordPage's entire `POST /api/auth/password/forgot` flow
 * unmodified; only the hero image, heading/body copy, and Sign In destination differ. */
export function PartnerForgotPasswordPage() {
  return (
    <ForgotPasswordPage
      heroSlides={PARTNER_RESET_REQUEST_SLIDES}
      signInHref="/partner-login"
      heading="Reset Password"
      bodyCopy="Enter your email address to reset your password"
      submitLabel="Submit"
    />
  );
}
